export default "__VITE_ASSET__Byx7y4KS__"